import { AuthState } from '@okta/okta-auth-js';

import { LocationGroupsMassUpdates } from '../../services/backend/LocationGroupsMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useLocationGroupsMassUpdates: () => LocationGroupsMassUpdates<AuthState> = () => {
  return useBaseApiClient(LocationGroupsMassUpdates);
};
